
import CalendarAdd from "../../../assets/filled/CalendarAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function CalendarAddIcon({ className, dataTestid = "CalendarAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <CalendarAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
